import { Divider } from "primereact/divider";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import { Description } from "../../../components/Description";
import styles from "../../../components/ListDescriptions/styles.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";

export function CadastralVNome({ cadastralVNome }: { cadastralVNome: any }) {
    const { t } = useTranslation();

    return (
        <Panel header={t("cadastral")}>

            {cadastralVNome && (
                <div>
                    <Divider align="left">
                        <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2' }}><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>
                            <span style={{ paddingLeft: '0.5rem' }}>
                                <b>Informações cadastrais</b>
                            </span>
                        </div>
                    </Divider>
                    <div className={styles.wrapper}>
                        <div className={styles.gridContainer}>
                            <Description key={'nome'} label={'Nome pesquisado'} value={cadastralVNome.nome} />
                            <Description key={'status'} label={'Status'} value={cadastralVNome.statusMensagem} />
                        </div>
                    </div>
                </div>
            )}

            {cadastralVNome?.pessoas && cadastralVNome.pessoas.length > 0 ? (
                <div>
                    <br></br>
                    <Divider align="left">
                        <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2' }}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                            <span style={{ paddingLeft: '0.5rem' }}>
                                <b>Pessoas encontradas</b>
                            </span>
                        </div>
                    </Divider>
                    <br></br>
                    <DataTable size="small" value={cadastralVNome.pessoas} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="nome" header={'Nome'}></Column>
                        <Column field="cpf" header={'CPF'}></Column>
                        <Column field="dataNascimento" header={t('Nascimento')}></Column>
                        <Column field="idade" sortable header={t('idade')}></Column>
                        <Column field="nomeMae" header={'Mãe'}></Column>
                        <Column field="nomePai" header={'Pai'}></Column>
                        <Column field="cidade" header={t('cidade')}></Column>
                        <Column field="uf" header={t('uf')}></Column>
                    </DataTable>
                </div>
            ) : (
                <div>
                    <br></br>
                    <NadaConsta />
                </div>
            )}

        </Panel>
    );
}
